<template>
  <c-button-menu
    v-if="locations.length > 1"
    :label="schoolname"
    outline
    :menu-options="{
      listItems: schoolMenuItems,
    }"
  >
  </c-button-menu>

  <!-- A single (or no) location leaves nothing to switch to: keep the same
       outlined chrome, but render it inert — no dropdown, no hover state. -->
  <c-button
    v-if="locations.length <= 1 && schoolname"
    :label="schoolname"
    outline
    tabindex="-1"
    class="tw-pointer-events-none"
  />
</template>

<script setup>
import CButton from "shared/components/wrappers/button/CButton.vue";
import CButtonMenu from "shared/components/wrappers/button/CButtonMenu.vue";
import { useMenuStore } from "store/modules/menuStore.js";
import { computed } from "vue";

const props = defineProps({
  schoolname: {
    type: String,
    default: "",
  },
  locations: {
    type: Array,
    required: true,
  },
});

// menuStore
const menuStore = useMenuStore();
const { loginAsSchool } = menuStore;

const schoolMenuItems = computed(() => {
  return props.locations.map((school) => ({
    label: school.name,
    onClick: () => {
      loginAsSchool(school);
    },
  }));
});
</script>
